import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { TodoKind } from 'generated/graphql';

type TargetType = 'Document' | undefined;

const ICONS: Record<NonNullable<TargetType>, Partial<Record<TodoKind, IconProp>>> = {
  Document: {
    EXPIRATION: ['fal', 'calendar-circle-exclamation'],
    NO_EXPIRATION_DATE: ['fal', 'calendar-xmark'],
  },
};

export const todoItemIconName = (targetType: TargetType, kind: TodoKind): IconProp =>
  (targetType && ICONS[targetType][kind]) || ['fal', 'calendar'];
